// Pide el viaje en cuanto arranca la app, en paralelo con la descarga del
// código de la ficha (antes se pedía al terminar esa descarga: ~1 s más
// de espera). La ficha la recoge con takeItineraryPrefetch.
import { BASEURL } from "../api";

const ROUTE = /^\/(?:es|en)\/itinerary\/([0-9a-fA-F]{24})\/?$/;
let pending = null;

export function startItineraryPrefetch() {
  try {
    const m = window.location.pathname.match(ROUTE);
    if (!m) return;
    const token = localStorage.getItem("token") || localStorage.getItem("googletoken") || "";
    const auth = token ? `Bearer ${token}` : "";
    pending = {
      id: m[1],
      auth,
      promise: fetch(`${BASEURL}/itineraries/${m[1]}`, {
        headers: { "Content-Type": "application/json", ...(auth ? { Authorization: auth } : {}) },
      }).catch(() => null),
    };
  } catch (e) {
    pending = null;
  }
}

// Devuelve la respuesta precargada si es de este viaje y con la misma
// sesión; si no, null y la ficha la pide como siempre. Solo se usa una vez.
export async function takeItineraryPrefetch(id, auth = "") {
  const p = pending;
  pending = null;
  if (!p || p.id !== id || p.auth !== (auth || "")) return null;
  const res = await p.promise;
  return res || null;
}
